import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const RegistrationsSvg = () => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.9949 16.9302L16.6137 16.3156C19.4764 16.4091 19.5204 16.3087 19.6462 16.0145L20.4327 14.0998L20.4912 13.9183L20.4272 13.7595C20.3935
      13.6756 20.2897 13.4253 18.5022 11.721V10.8245C20.5647 8.83765 20.5207 8.7359 20.4032 8.44509L19.6201 6.51046C19.5025 6.22034 19.4578 6.1069
      16.6157 6.18459L15.997 5.54521C16.0608 4.60341 16.0284 3.65754 15.9 2.72234L15.8203 2.54153L13.7757 1.64778C13.4745 1.51028 13.3687 1.46078 11.4382
      3.56315L10.5705 3.55009C8.58296 1.42846 8.48878 1.46696 8.19109 1.58728L6.29015 2.3559C5.99247 2.47621 5.88728 2.51884 6.00278 5.40634L5.38884
      6.01821C2.52746 5.92471 2.48346 6.02646 2.35903 6.31934L1.57115 8.23471L1.50928 8.41828L1.5739 8.57778C1.60759 8.66028 1.70728 8.90778 3.4989
      10.6142V11.5079C1.4364 13.4948 1.48109 13.5965 1.59934 13.888L2.38171 15.8247C2.50134 16.121 2.54397 16.2262 5.3854 16.152L6.00415 16.7948C5.94002
      17.7351 5.97157 18.6796 6.09834 19.6135L6.17809 19.7957L8.23578 20.695C8.53484 20.8201 8.63865 20.8648 10.5637 18.77L11.4313 18.781C13.4216 20.9053
      13.5233 20.8641 13.8142 20.7465L15.711 19.98C16.0107 19.861 16.1152 19.8191 15.9949 16.9302ZM7.84253 12.445C7.60263 11.818 7.55324 11.1342 7.70055
      10.4792C7.84786 9.82429 8.18531 9.22745 8.67057 8.76359C9.15582 8.29974 9.76726 7.98952 10.4282 7.87188C11.0891 7.75423 11.77 7.8344 12.3855 8.10231C13.001
      8.37022 13.5237 8.81395 13.888 9.37781C14.2522 9.94168 14.4419 10.6006 14.4331 11.2718C14.4242 11.943 14.2174 12.5967 13.8385 13.1508C13.4595 13.7049 12.9254
      14.1348 12.303 14.3865C11.4539 14.7185 10.5078 14.7006 9.67187 14.3368C8.83591 13.9729 8.17813 13.2927 7.84253 12.445Z"
      fill="currentColor"
    />
  </svg>
);

const Registrations = (props: IIconProps) => <Icon component={RegistrationsSvg} {...props} />;

export default Registrations;
